
import { Link } from 'react-router-dom';
import { useState, useEffect } from 'react';
import { createClient } from '@supabase/supabase-js';

const HormigonDesactivado = () => {
  const SUPABASE_URL = import.meta.env.VITE_PUBLIC_SUPABASE_URL;
  const SUPABASE_ANON_KEY = import.meta.env.VITE_PUBLIC_SUPABASE_ANON_KEY;
  const supabase = createClient(SUPABASE_URL, SUPABASE_ANON_KEY);

  const [images, setImages] = useState<string[]>([]);

  useEffect(() => {
    const loadImages = async () => {
      try {
        const { data, error } = await supabase.storage
          .from('HormiPremium')
          .list('Dezactivado', {
            limit: 6,
            sortBy: { column: 'name', order: 'asc' },
          });

        if (error) throw error;

        if (data) {
          const imageFiles = data
            .filter((file) => {
              const ext = file.name.toLowerCase();
              return ext.endsWith('.jpg') || ext.endsWith('.jpeg') || ext.endsWith('.png');
            })
            .slice(0, 6)
            .map((file) => {
              const fileName = encodeURIComponent(file.name);
              return `${SUPABASE_URL}/storage/v1/object/public/HormiPremium/Dezactivado/${fileName}`;
            });

          setImages(imageFiles);
        }
      } catch (error) {
        console.error('Error loading images:', error);
      }
    };

    loadImages();
  }, []);

  const features = [
    {
      icon: 'ri-landscape-line',
      title: 'Acabado Natural',
      description: 'Árido visto que crea una textura rústica y elegante',
    },
    {
      icon: 'ri-footprint-line',
      title: 'Máxima Adherencia',
      description: 'Superficie antideslizante perfecta para exteriores',
    },
    {
      icon: 'ri-leaf-line',
      title: 'Integración Paisajística',
      description: 'Se integra perfectamente con jardines y espacios naturales',
    },
    {
      icon: 'ri-water-flash-line',
      title: 'Drenaje Excelente',
      description: 'Permite la evacuación natural del agua de lluvia',
    },
  ];

  const applications = [
    'Jardines y zonas verdes',
    'Caminos peatonales',
    'Plazas y parques',
    'Entradas de viviendas',
    'Zonas de piscina',
    'Espacios públicos',
  ];

  return (
    <section id="hormigon-desactivado" className="py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid lg:grid-cols-2 gap-12 items-center mb-16">
          <div className="order-2 lg:order-1">
            <div className="grid grid-cols-2 gap-4">
              {images.length > 0 ? (
                images.slice(0, 4).map((image, index) => (
                  <div
                    key={index}
                    className={`rounded-xl overflow-hidden shadow-lg ${
                      index === 0 ? 'col-span-2 h-80' : 'h-64'
                    }`}
                  >
                    <img
                      src={image}
                      alt={`Hormigón Desactivado ${index + 1}`}
                      className="w-full h-full object-cover object-top hover:scale-110 transition-transform duration-500"
                    />
                  </div>
                ))
              ) : (
                <div className="col-span-2 h-80 bg-gray-200 rounded-xl flex items-center justify-center">
                  <p className="text-gray-500">Cargando imágenes...</p>
                </div>
              )}
            </div>
          </div>

          <div className="order-1 lg:order-2">
            <div className="inline-flex items-center gap-2 bg-emerald-100 text-emerald-700 px-4 py-2 rounded-full text-sm font-semibold mb-6">
              <i className="ri-landscape-line"></i>
              <span>Acabado Natural</span>
            </div>
            <h2 className="text-4xl md:text-5xl font-bold text-dark mb-6 leading-tight">
              Hormigón Desactivado
            </h2>
            <p className="text-secondary text-lg leading-relaxed mb-8">
              El <strong>hormigón desactivado</strong> ofrece un acabado <strong>rústico y natural</strong> que deja el árido a la vista. Es ideal para espacios que buscan integrarse con el entorno natural, proporcionando una textura única y <strong>máxima adherencia</strong>.
            </p>
            <p className="text-secondary text-lg leading-relaxed mb-8">
              Este tipo de pavimento es perfecto para <strong>jardines, parques y zonas peatonales</strong>, combinando funcionalidad con una estética natural que se integra armoniosamente con el paisaje.
            </p>

            <div className="grid sm:grid-cols-2 gap-4 mb-8">
              {features.map((feature, index) => (
                <div key={index} className="flex items-start gap-3">
                  <div className="w-10 h-10 bg-emerald-100 rounded-lg flex items-center justify-center flex-shrink-0">
                    <i className={`${feature.icon} text-emerald-600 text-xl`}></i>
                  </div>
                  <div>
                    <h4 className="font-bold text-dark mb-1">{feature.title}</h4>
                    <p className="text-secondary text-sm">{feature.description}</p>
                  </div>
                </div>
              ))}
            </div>

            <Link
              to="/servicios/hormigon-desactivado"
              className="inline-flex items-center gap-2 px-8 py-4 bg-emerald-600 text-white rounded-full font-semibold hover:bg-emerald-700 transition-all shadow-lg hover:shadow-xl cursor-pointer whitespace-nowrap"
            >
              Ver detalles completos
              <div className="w-5 h-5 flex items-center justify-center">
                <i className="ri-arrow-right-line"></i>
              </div>
            </Link>
          </div>
        </div>

        <div className="bg-white rounded-2xl p-8 md:p-12 shadow-lg">
          <h3 className="text-2xl font-bold text-dark mb-6">
            Aplicaciones del Hormigón Desactivado
          </h3>
          <div className="grid sm:grid-cols-2 md:grid-cols-3 gap-4">
            {applications.map((app, index) => (
              <div
                key={index}
                className="flex items-center gap-3 p-4 bg-gray-50 rounded-lg"
              >
                <div className="w-8 h-8 bg-emerald-100 rounded-full flex items-center justify-center flex-shrink-0">
                  <i className="ri-check-line text-emerald-600 font-bold"></i>
                </div>
                <span className="text-dark font-medium">{app}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default HormigonDesactivado;
